export function encodePermissions<T = unknown>(data: T): string {
  try {
    return btoa(JSON.stringify(data))
  } catch (err) {
    return ''
  }
}

export function decodePermissions<T = unknown>(encoded: string | null, fallback: T): T {
  if (!encoded) return fallback
  try {
    return JSON.parse(atob(encoded)) as T
  } catch (err) {
    return fallback
  }
}
